import Tooltip from '@/components/Tooltip'
import { Money, Eye, EyeClosed } from '@/Icons'

import styles from './styles.module.scss'

import { Friend } from '@/domain/entities/friend.entity'

interface IProps {
  friend: Friend
  indicatorId: string
  totalReceived: string
  totalReceivable: string
  handleOpenModal: (data: Friend) => void
  handleShowIndications: (id: string) => void
}

export const DataTable = ({
  friend,
  indicatorId,
  handleOpenModal,
  handleShowIndications,
  totalReceived,
  totalReceivable,
}: IProps) => {
  return (
    <tr key={friend.id}>
      <td>{friend.name}</td>
      <td>{friend.code}</td>
      <td>{friend.email}</td>
      <td>{friend.chave_pix}</td>
      <td>{friend.phone}</td>
      <td>{friend.second_phone}</td>
      <td style={{ textAlign: 'center' }}>{friend.total_receivable}</td>
      <td>{totalReceivable}</td>
      <td>{totalReceived}</td>
      <td className={styles.actions}>
        <Tooltip title="Pagar">
          <Money onClick={() => handleOpenModal(friend)} size={24} />
        </Tooltip>
        {friend.id !== indicatorId && (
          <Tooltip title="Ver indicações">
            <Eye onClick={() => handleShowIndications(friend.id)} size={24} />
          </Tooltip>
        )}
        {friend.id === indicatorId && (
          <Tooltip title="Fechar indicações">
            <EyeClosed
              onClick={() => handleShowIndications(friend.id)}
              size={24}
            />
          </Tooltip>
        )}
      </td>
    </tr>
  )
}
